export default __webpack_public_path__ + "static/media/SFF.47ecd8e8.png";